define.alias("shared/components/shared/modal/banner", "preview-grid/components/shared/modal/banner");